import axios from "axios"
import { useMutation } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { IAuthOtpRequest, IAuthOtpResponse2 } from "../interface"
import { API_OTP_AUTH_URL } from "../constants"
import { getFingerPrint as getFingerprint } from "../../utils/fingerprint"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../utils/constants"

async function otpAuthRequest(token: string | null, req: IAuthOtpRequest) {
  const response = await axios(API_OTP_AUTH_URL, {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    data: req,
  })
  return response.data
}

export const useOtpAuthRequest = () => {
  const [searchParams] = useSearchParams()
  const exchangeToken = searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)
  const fingerprint = getFingerprint(true)!

  return useMutation<IAuthOtpResponse2, void, { otp: string }>({
    mutationFn: (req) =>
      otpAuthRequest(exchangeToken, { code: req.otp, fingerprint, url: "" }),
    retry: false,
  })
}
